module.exports = __webpack_public_path__ + "static/media/MementoMori-Regular.64a34362.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MementoMori-Regular.ttf
// module id = 2140
// module chunks = 53